var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 35,
    viewBox: "0 0 66 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.872 34.432C9.76 34.432 7.856 34.016 6.16 33.184C4.496 32.352 3.184 31.056 2.224 29.296C1.296 27.504 0.832 25.248 0.832 22.528V7.984H9.952V21.04C9.952 23.056 10.32 24.496 11.056 25.36C11.824 26.224 12.896 26.656 14.272 26.656C15.168 26.656 15.984 26.448 16.72 26.032C17.456 25.616 18.048 24.96 18.496 24.064C18.944 23.136 19.168 21.952 19.168 20.512V7.984H28.288V34H19.6V26.656L21.28 28.72C20.384 30.64 19.088 32.08 17.392 33.04C15.696 33.968 13.856 34.432 11.872 34.432Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7321 34L44.4201 13.6L44.3721 20.368L30.2601 0.399998H40.9641L49.9881 13.408L45.4281 13.456L54.3081 0.399998H64.5801L50.4681 19.984V13.264L65.3481 34H54.4041L45.2361 20.32H49.6041L40.5801 34H29.7321Z",
    fill: "#629BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4b1e4728b23c8dd28e0b3696c3b4d2a.svg";
export { ForwardRef as ReactComponent };